export enum LocationSortType {
  CODE = 'CODE',
  CUSTOM_NAME = 'CUSTOM_NAME',
  TERRITORY = 'TERRITORY',
  TOTAL = 'TOTAL',
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED'
}
